import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import "@/app/pages/industryAnalysis/industry.scss";
import showMoreIcon from "@/assets/icons/svg/down-arrow-circle-industry.svg";
import showLessIcon from "@/assets/icons/svg/up-arrow-circle-industry.svg";
import { Link } from "react-router-dom";

const IndustryCountry = ({ title, countryCrawl, urlSelector }) => {
  const { t } = useTranslation();
  const countriesHeadingSuffix = t(
    "industryAnalysis.industryCountry.countriesHeadingSuffix"
  );
  const viewMoreLabel = t("industryAnalysis.industryCountry.viewMoreLabel");
  const viewLessLabel = t("industryAnalysis.industryCountry.viewLessLabel");


  const industryCountries = countryCrawl.map(data => JSON.parse(data));

  const [itemsToShow, setItemsToShow] = useState(Number(t("industryAnalysis.industryCountry.itemsToShow"))); 

  const [expanded, setExpanded] = useState(false);
  const viewMoreRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if(countryCrawl.length <= itemsToShow) {
      setItemsToShow(countryCrawl.length);
    }
  }, []);

  const handleViewMoreLess = () => {
   if(expanded) {
    window.scrollTo({
      top: viewMoreRef.current?.offsetTop,
      behavior: 'smooth'
    }); 
  }
    setExpanded(!expanded);
  };

  return (
    <>
      <div className="section">
        <div className="industryCountryCrawlWrapper" ref={viewMoreRef}>
          <div className="container">
            <a className="anchor" name="null"></a>
            <div className="title">
              {title} {countriesHeadingSuffix}
            </div>

            <div className="text-center text-md-start px-30">
              {expanded ? industryCountries.map((data) => (
                    <>
                      <div className="col-6 col-md-3 data pad-rlb-0 display-inline-block">
                        <Link
                          className="sideLink"
                          to={`/business-directory/company-information.${urlSelector}.${data.countryISOAlpha2Code}.html`}
                        >
                          {" "}
                          {data.name}
                          <span className="number-countries">
                            {" "}
                            ({data.candidatesMatchedQuantity.toLocaleString()})
                          </span>
                        </Link>
                      </div>
                    </>
                  ))  :  industryCountries.slice(0, itemsToShow).map((data) => (
                    <>
                      <div className="col-6 col-md-3 data pad-rlb-0 display-inline-block">
                        <Link
                          className="sideLink"
                          to={`/business-directory/company-information.${urlSelector}.${data.countryISOAlpha2Code}.html`}
                        >
                          {" "}
                          {data.name}
                          <span className="number-countries">
                            {" "}
                            ({data.candidatesMatchedQuantity.toLocaleString()})
                          </span>
                        </Link>
                      </div>
                    </>
                  ))}
            </div>

            <button
              className="show-more link viewMore"
              onClick={handleViewMoreLess}
            >
              <>
                {expanded ? viewLessLabel : viewMoreLabel}{" "}
                <img
                  src={expanded ? showLessIcon : showMoreIcon}
                  className="viewMoreLessIcon"
                />
              </>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default IndustryCountry;
